import service from './index'

const resource = service.resource('race-questions{/id}')
const resourceQuestion = service.resource('race-questions/by-race{/raceId}')
const resourceAnswer = service.resource('race-questions/all-answers{/raceQuestionId}')

const resourceRunnerAnswer = service.resource('race-questions/runner-answer/{raceId}/{runnerId}')
const resourceRunnerPostAnswer = service.resource('race-questions/post-run-runner-answer/{raceId}/{runnerId}')

export default {
  createOne (question) {
    return resource.save({}, question)
  },
  updateOne (question) {
    return resource.update({}, question)
  },
  get (raceId){
   return resourceQuestion.get({raceId: raceId})
  },

  getQuestionAnswer(raceQuestionId){
    return resourceAnswer.get({raceQuestionId: raceQuestionId})
  },

  //Get Runner Anser for Race

  getRunnerAnswer(raceId,runnerId){
    return resourceRunnerAnswer.get({raceId: raceId,runnerId:runnerId})
  },

  getRunnerPostAnswer(raceId,runnerId){
    return resourceRunnerPostAnswer.get({raceId: raceId,runnerId:runnerId})
  }
}




// WEBPACK FOOTER //
// ./src/services/raceQuestion.js